import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type AppRole = 'admin' | 'mediator' | 'seeker';

export const useUserRole = () => {
  return useQuery({
    queryKey: ['userRole'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) return null;

      // Check each role
      const { data: isAdmin } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'admin'
      });

      const { data: isMediator } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'mediator'
      });

      const { data: isSeeker } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'seeker'
      });

      if (isAdmin) return 'admin';
      if (isMediator) return 'mediator';
      if (isSeeker) return 'seeker';
      
      return null;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });
};
